// extracted by mini-css-extract-plugin
export default {"overviewLocation":"overviewLocation__OGVkM","reviewsLink":"reviewsLink__OWIzO","yelpAverageRating":"yelpAverageRating__NTllN","titleLinks":"titleLinks__MWIxN"};